(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-video-carousel"] && !Shopify.designMode) return;
  try {
    
  class ScVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sc-vc__track');
      this.videos = [...this.querySelectorAll('.sc-vc__video')];
      this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.closest('.sc-vc')
        ?.querySelectorAll('.sc-vc__arrow')
        .forEach((button) => {
          button.addEventListener('click', () => this.page(button.dataset.direction));
        });

      this.querySelectorAll('.sc-vc__sound').forEach((button) => {
        button.addEventListener('click', (event) => this.toggleSound(event, button));
      });

      // Only the clips actually on screen are allowed to load and play. The
      // threshold is high enough that a card half-swiped into view stays still.
      this.visible = new Set();
      this.observer = new IntersectionObserver((entries) => this.react(entries), {
        root: this.track,
        threshold: 0.6,
      });

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    // Entries are recorded into a set and the whole row is then reconciled from
    // it. Acting on each entry as it arrives looked correct but raced: a scroll
    // delivers "leaving" and "entering" records in no guaranteed order, so a
    // clip could be told to play and then immediately paused by a stale record
    // from the same burst. Reconciling from one source of truth is idempotent.
    react(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.visible.add(entry.target);
        } else {
          this.visible.delete(entry.target);
        }
      });

      if (this.calm.matches) return;

      this.videos.forEach((video) => {
        if (!this.visible.has(video)) {
          video.pause();
          return;
        }

        // preload="none" means there is nothing buffered until the first play,
        // so the load has to be asked for explicitly.
        if (!video.dataset.loaded) {
          video.load();
          video.dataset.loaded = 'true';
        }

        if (video.paused) {
          video.play().catch(() => {
            // Autoplay refused. The poster stays, which is a fine resting state.
          });
        }
      });
    }

    toggleSound(event, button) {
      event.preventDefault();

      const video = button.closest('.sc-vc__media').querySelector('.sc-vc__video');
      const unmuting = video.muted;

      // One soundtrack at a time.
      if (unmuting) {
        this.videos.forEach((other) => {
          if (other !== video) other.muted = true;
        });
        this.querySelectorAll('.sc-vc__sound').forEach((other) => {
          if (other !== button) other.setAttribute('aria-pressed', 'false');
        });
      }

      video.muted = !unmuting;
      button.setAttribute('aria-pressed', String(unmuting));
    }

    page(direction) {
      const card = this.querySelector('.sc-vc__item');
      if (!card) return;

      const step = card.getBoundingClientRect().width + 16;
      this.track.scrollBy({
        left: direction === 'next' ? step : -step,
        behavior: this.calm.matches ? 'instant' : 'smooth',
      });
    }
  }

  if (!customElements.get('sc-video-carousel')) {
    customElements.define('sc-video-carousel', ScVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
